import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useValidationSchemaPhone } from './use-validation-schema-phone';
import { useValidationSchemaTelegram } from './use-validation-schema-telegram';
import * as Yup from 'yup';

export const useValidationSchemaProfile = () => {
  const { t } = useTranslation();
  const telegramSchema = useValidationSchemaTelegram();
  const phoneSchema = useValidationSchemaPhone();
  const validationSchema = useMemo(() => {
    return Yup.object().shape(
      {
        phoneRt: Yup.object().shape({
          value: phoneSchema.test('test', t('errors.noValue'), function (value) {
            const telegramRt = this.from[1].value.telegramRt;
            return !(!telegramRt && !value);
          }),
          country: Yup.string(),
        }),
        telegramRt: telegramSchema.when('phoneRt.value', {
          is: (phoneRt: string) => !phoneRt,
          then: (schema) => schema.required(t('errors.noValue')),
          otherwise: (schema) => schema.notRequired(),
        }),
      },
      [['phoneRt', 'telegramRt']],
    );
  }, [t, phoneSchema]);

  return { validationSchema };
};
